<div class="scrap-categories-container">

  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Scrap Categories</h1>
        <p>Manage and view all scrap material categories</p>
      </div>
      <button class="create-btn" (click)="toggleCreateForm()">
        <i class="fas" [ngClass]="showCreateForm ? 'fa-times' : 'fa-plus'"></i>
        {{ showCreateForm ? 'Cancel' : 'New Category' }}
      </button>
    </div>
  </div>

  <!-- Notification -->
  <div class="notification" *ngIf="notification.show" [ngClass]="notification.type">
    <i class="fas" [ngClass]="{
      'fa-check-circle': notification.type === 'success',
      'fa-times-circle': notification.type === 'error',
      'fa-info-circle':  notification.type === 'info'
    }"></i>
    <span>{{ notification.message }}</span>
    <button class="notif-close" (click)="closeNotification()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Inline Create Form -->
  <div class="create-form-panel" *ngIf="showCreateForm">
    <div class="panel-header">
      <h2><i class="fas fa-recycle"></i> New Scrap Category</h2>
    </div>

    <form (ngSubmit)="onSubmit()" #categoryForm="ngForm" class="panel-body">
      <!-- General error -->
      <div class="error-banner" *ngIf="hasError('general')">
        <i class="fas fa-exclamation-circle"></i>
        {{ getError('general') }}
      </div>

      <div class="form-row">
        <!-- Name -->
        <div class="form-group">
          <label for="categoryName" class="form-label">
            Category Name <span class="required">*</span>
          </label>
          <input
            type="text"
            id="categoryName"
            name="categoryName"
            [(ngModel)]="categoryData.name"
            [class.error]="hasError('name')"
            class="form-input"
            placeholder="e.g. Iron, Copper, Paper"
            required
            maxlength="100"
            [disabled]="isSubmitting">
          <div class="field-error" *ngIf="hasError('name')">
            <i class="fas fa-exclamation-triangle"></i> {{ getError('name') }}
          </div>
        </div>

        <!-- Image name -->
        <div class="form-group">
          <label for="categoryImage" class="form-label">Image</label>
          <input
            type="text"
            id="categoryImage"
            name="categoryImage"
            [(ngModel)]="categoryData.image"
            [class.error]="hasError('image')"
            class="form-input"
            placeholder="e.g. iron.png (optional)"
            [disabled]="isSubmitting">
          <div class="field-error" *ngIf="hasError('image')">
            <i class="fas fa-exclamation-triangle"></i> {{ getError('image') }}
          </div>
        </div>
      </div>

      <!-- Is Scrap toggle -->
      <div class="form-group toggle-group">
        <label class="form-label">Is Scrap?</label>
        <label class="toggle-switch">
          <input
            type="checkbox"
            name="isScrap"
            [(ngModel)]="categoryData.isScrap"
            [disabled]="isSubmitting">
          <span class="toggle-slider"></span>
        </label>
        <span class="toggle-hint">{{ categoryData.isScrap ? 'Yes — this is a scrap material' : 'No — non-scrap category' }}</span>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="onCancelCreate()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || !categoryForm.valid">
          <span *ngIf="!isSubmitting"><i class="fas fa-plus-circle"></i> Create Category</span>
          <span *ngIf="isSubmitting"><i class="fas fa-spinner fa-spin"></i> Creating...</span>
        </button>
      </div>
    </form>
  </div>

  <!-- Search + List -->
  <div class="list-section">
    <div class="search-bar">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
        placeholder="Search categories..."
        class="search-input">
    </div>

    <!-- Loading -->
    <div class="loading-state" *ngIf="isLoading">
      <i class="fas fa-spinner fa-spin"></i>
      <span>Loading categories...</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!isLoading && filteredCategories.length === 0">
      <i class="fas fa-recycle"></i>
      <p *ngIf="searchQuery">No categories match "<strong>{{ searchQuery }}</strong>"</p>
      <p *ngIf="!searchQuery">No scrap categories yet. Click <strong>New Category</strong> to add one.</p>
    </div>

    <!-- Categories Grid -->
    <div class="categories-grid" *ngIf="!isLoading && filteredCategories.length > 0">
      <div class="category-card" *ngFor="let category of filteredCategories">
        <div class="category-image">
          <img
            *ngIf="category.image"
            [src]="cdnUrl + category.image"
            [alt]="category.name"
            (error)="$any($event.target).style.display='none'">
          <div class="category-image-placeholder" *ngIf="!category.image">
            <i class="fas fa-recycle"></i>
          </div>
        </div>
        <div class="category-info">
          <h3 class="category-name">{{ category.name }}</h3>
          <span class="category-id">ID: {{ category.id }}</span>
        </div>
      </div>
    </div>

    <!-- Result count -->
    <div class="result-count" *ngIf="!isLoading && filteredCategories.length > 0">
      Showing {{ filteredCategories.length }} of {{ categories.length }} categories
    </div>
  </div>

</div>
